import { setGlobalMessage, setLoading } from './app'
import {
    ERROR_MESSAGES,
    ALERT_SEVERITY
} from '../constants';
import SessionManager from '../utils/session';


export const Catch = (error,
    dispatch,
    stopGlobalLoading = true,
    setGlobalErrorMessage = true) => {

    stopGlobalLoading &&
        dispatch(setLoading(false));

    const response = error && error.response;
    let errorMessage = ERROR_MESSAGES.SERVER_FAULT;
    if (response && response.data && response.data.errorMessage) {
        errorMessage = response.data.errorMessage;
    }

    // Log full error for debugging (network/response/body/stack)
    // This helps when the UI only shows the generic message in a toast.
    console.error('API error caught by Catch:', error);

    // Include HTTP status in the user-facing message when available
    const statusInfo = response ? ` (${response.status}${response.statusText ? ' ' + response.statusText : ''})` : '';
    setGlobalErrorMessage && dispatch(setGlobalMessage(`${errorMessage}${statusInfo}`, ALERT_SEVERITY.ERROR));

    if (response && response.status === 440) {
        SessionManager.setAuthToken(null);
        SessionManager.setAuthRToken(null);
        SessionManager.setAuthUser(null);
        window.location = "/portal/signin";
    }
}


